import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../lib/api';
import { ReferenceForm } from '../components/stock/ReferenceForm';

export function ReferenceNouveauPage(): JSX.Element {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: api.references.create,
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: ['references'] });
      navigate(`/references/${String(data.reference.id)}`);
    },
    onError: (err: unknown) => {
      setError(err instanceof ApiError ? err.message : 'Erreur création.');
    },
  });

  return (
    <div className="max-w-5xl">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Nouvelle référence</h1>
      </header>
      {error !== null && (
        <div className="mb-4 text-xs text-red-300 bg-red-900/20 border border-red-900/50 rounded-md px-3 py-2">
          {error}
        </div>
      )}
      <ReferenceForm
        submitting={mutation.isPending}
        onSubmit={(b): void => mutation.mutate(b)}
        onCancel={(): void => navigate('/references')}
      />
    </div>
  );
}
